function FeatureList() {
  const features = [
    {
      icon: "fa-light fa-wrench",
      title: "Lorem Ipsum",
      description:
        "ProofTec quickly confirms or dismisses damage claims in real time.",
    },
    {
      icon: "fa-light fa-key",
      title: "Lorem Ipsum",
      description:
        "ProofTec quickly confirms or dismisses damage claims in real time.",
    },
    {
      icon: "fa-light fa-money-bill-simple-wave",
      title: "Lorem Ipsum",
      description:
        "ProofTec quickly confirms or dismisses damage claims in real time.",
    },
    {
      icon: "fa-light fa-calculator",
      title: "Lorem Ipsum",
      description:
        "ProofTec quickly confirms or dismisses damage claims in real time.",
    },
  ];
  return (
    <section className="my-5 container d-flex justify-content-between">
      {features.map((feature, index) => (
        <div key={index}>
          <i className={`fa ${feature.icon} fs-4 color-gradient`}></i>
          <div className="my-3 feature-title-container">
            <div className="vertical-pipe"></div>
            <h3 className="fs-5 fw-bold">{feature.title}</h3>
          </div>
          <p>{feature.description}</p>
        </div>
      ))}
    </section>
  );
}

export default FeatureList;
